module.exports = __webpack_public_path__ + "static/media/went_wrong.5d65177f.svg";